module.exports = __webpack_public_path__ + "static/feature-information-55d266c917081fe22e7150ff060e78d5.png";